import { useSelector } from 'react-redux';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { RootState } from '../app/store';
import { saveRedirectUrl } from '../pages/Auth/authSCG';
import { plugAndPlayConfig } from '../config/plugAndPlay';

interface PrivateRouteProps {
  component: React.FunctionComponent;
  exact?: boolean;
  path: string;
  permission?: string;
}

//สร้าง private route ใช้ useContext อ่าน permission object
export default function PrivateRoute({
  component: Component,
  permission,
  ...props
}: PrivateRouteProps) {
  const { user } = useSelector((state: RootState) => state.userProfile);
  const history = useHistory();

  // Plug and Play mode: bypass all permission checks
  if (plugAndPlayConfig.isEnabled) {
    if (!user) {
      const { pathname, search } = history.location;
      saveRedirectUrl(`${pathname}${search}`);
      return <Redirect to="/login" />;
    }
    // Allow access to all routes in Plug and Play mode
    return (
      <Route {...props}>
        <Component />
      </Route>
    );
  }

  // Legacy mode: normal permission checking
  const systems = user?.roles.map((role) => {
    const [system] = role.split('.');
    return system;
  });

  const hasPermission =
    systems?.some((system) => system === 'documentManagement') &&
    (!permission ||
      user?.permissions.some(
        (userPermission) => userPermission === permission
      ));

  if (!user) {
    const { pathname, search } = history.location;
    saveRedirectUrl(`${pathname}${search}`);

    return <Redirect to="/login" />;
  } else if (hasPermission) {
    return (
      <Route {...props}>
        <Component />
      </Route>
    );
  }
  return <Redirect to="/error/403" />;
}
